import { render, staticRenderFns } from "./OrderOverviewActivitiesList.vue?vue&type=template&id=073bcb50&scoped=true"
import script from "./OrderOverviewActivitiesList.vue?vue&type=script&lang=ts"
export * from "./OrderOverviewActivitiesList.vue?vue&type=script&lang=ts"
import style0 from "./OrderOverviewActivitiesList.vue?vue&type=style&index=0&id=073bcb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073bcb50",
  null
  
)

export default component.exports